import axios from 'axios'
import Qs from 'qs'
import { protocol } from '@/config'

export default {
  giftCard: ({ courseId }, config = {}) =>
    axios.post(`/activity/giftCard`, { courseId }, config),
  // getCourses: ({type, subject, grade, page}, config = {}) => axios.get(`courses/${type}/${subject}/${grade}/${page ? page + '/' : ''}`, config),
  // 课程标准化
  getCourses: ({ location, provinceId, grade, courseType }, config = {}) =>
    axios.get(`courses/list/1/${location}/${provinceId}/${grade}/${courseType}`, config),
  courseListAdv: ({ subject, grade, page }, config = {}) =>
    axios.get(`courseListAdv/${subject}/${grade}/${page}/`, config),
  getCourseDetail: ({ courseId, classId = 0 }, config = {}) =>
    axios.get(`course/${courseId}/${classId}`, config),
  courseCollect: (data, config = {}) =>
    axios.post(
      `${protocol}//online.xueersi.com/Courses/ajaxCollect/`,
      Qs.stringify(data),
      config
    ), // 课程收藏
  courseComment: (data, config = {}) =>
    axios.post(
      `${protocol}//online.xueersi.com/courses/ajaxCommList/`,
      Qs.stringify(data),
      config
    ), // 课程评论
  getCourseRecommend: ({ subject, grade }, config = {}) =>
    axios.get(`courseRecommend/${subject}/${grade}/`, config),
  postCommentContent: (data, config = {}) =>
    axios.post(
      `${protocol}//online.xueersi.com/courses/addCourseComm/`,
      Qs.stringify(data),
      config
    ), // 提交评论
  getPreSaleStatus: ({ courseId, classId, checkType }, config = {}) =>
    axios.get(`getPreSaleStatus/${courseId}${classId ? '/' + classId : ''}${checkType == 2 ? '/' + checkType : ''}`, config),
  getAddCart: (params, config = {}) => axios.post('cart/addCart', params, config), // 添加购物车
  getCartCount: (config = {}) => axios.get('cart/getCartCount', config), // 获取购物车数量
  getCouponList: (config = {}) => axios.post('coupon/list', config), // 获取劵列表
  getCoupon: (config = {}) => axios.post('coupon/get', config) // 领取券
}



// WEBPACK FOOTER //
// ./src/networks/api/Course/index.js